import React from "react";
import { useNavigate } from "react-router";
import { CircleCheck, ArrowLeft } from "lucide-react";

export default function ResetPasswordSuccess() {
  const navigate = useNavigate();

  return (
    <div className="flex justify-center items-center h-screen ">
      <div className=" p-10 w-full max-w-md text-center">
        <CircleCheck className="w-14 h-14 mx-auto text-green-600 mb-2 rounded-full p-3 bg-green-200" />
        <h2 className="text-4xl font-bold text-[#222] mb-4">Password reset</h2>
        <p className="text-gray-600 mb-6">
          Your password has been successfully reset. Click below to log in
          magically.
        </p>
        <button
          onClick={() => navigate("/login")}
          className="flex gap-4 justify-center w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 cursor-pointer"
        >
          <ArrowLeft />
          Go to Login
        </button>
      </div>
    </div>
  );
}
